/* Cobify · Ficha de producto: packs con color/batería, precios, fechas de entrega y barra fija.
   Código propio para Dawn. Añade al carrito con la Cart API de Shopify (una línea por variante). */
(function () {
  'use strict';

  /* ───────── utilidades ───────── */
  function formatMoney(cents, format) {
    var fmt = format || '{{amount_with_comma_separator}} €';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function delimit(number, precision, thousands, decimal) {
      if (isNaN(number) || number == null) return '0';
      var fixed = (Number(number) / 100).toFixed(precision);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var m = fmt.match(placeholder);
    var value;
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': value = delimit(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = delimit(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = delimit(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = delimit(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = delimit(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = delimit(cents, 0, ' ', ','); break;
      default: value = delimit(cents, 2, ',', '.');
    }
    return m ? fmt.replace(placeholder, value) : value;
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  function el(tag, cls, html) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (html != null) node.innerHTML = html;
    return node;
  }

  var BATTERY_ICON =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
    '<rect x="2" y="7" width="17" height="10" rx="2"></rect><path d="M22 11v2"></path><path d="M11 9l-2 3h3l-2 3"></path></svg>';

  /* ───────── Packs ───────── */
  class CobifyPacks extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      var dataEl = this.querySelector('script[data-cobify-packs-data]');
      if (!dataEl) return;
      try {
        this.cfg = JSON.parse(dataEl.textContent);
      } catch (e) {
        console.error('Cobify packs: datos no válidos', e);
        return;
      }
      this._ready = true;
      this.sectionId = this.dataset.section;
      this.variants = this.cfg.variants || [];
      if (!this.variants.length) return;

      var keyword = String(this.cfg.keyword || '').toLowerCase();
      this.hasBattery = function (title) {
        return !!keyword && String(title).toLowerCase().indexOf(keyword) !== -1;
      };
      this.colorOf = function (title) {
        return String(title).split(' + ')[0].trim();
      };

      var self = this;
      this.byKey = {};
      this.colors = [];
      this.anyBattery = false;
      this.variants.forEach(function (v) {
        var c = self.colorOf(v.title);
        var b = self.hasBattery(v.title);
        if (b) self.anyBattery = true;
        self.byKey[self.key(c, b)] = v;
        if (self.colors.indexOf(c) === -1) self.colors.push(c);
      });

      this.swatchHex = {};
      String(this.cfg.swatches || '')
        .split(/\r?\n/)
        .forEach(function (line) {
          var i = line.lastIndexOf(':');
          if (i < 1) return;
          var name = line.slice(0, i).trim().toLowerCase();
          var hex = line.slice(i + 1).trim();
          if (name && hex) self.swatchHex[name] = hex;
        });

      var start = this.variants.find(function (v) { return v.available; }) || this.variants[0];
      this.units = [{ color: this.colorOf(start.title), battery: this.hasBattery(start.title) }];

      this.packs = Array.prototype.slice.call(this.querySelectorAll('.cobify-pack'));
      this.addEventListener('change', function (e) {
        if (e.target.classList && e.target.classList.contains('cobify-pack__radio')) {
          self.select(e.target.closest('.cobify-pack'));
        }
      });
      this.addEventListener('click', function (e) {
        var btn = e.target.closest('button[data-unit]');
        if (!btn || !self.contains(btn)) return;
        e.preventDefault();
        if (btn.disabled) return;
        self.onUnitClick(btn);
      });

      var checked = this.querySelector('.cobify-pack__radio:checked');
      this.select(checked ? checked.closest('.cobify-pack') : this.packs[0]);

      this._onSubmit = this.onSubmit.bind(this);
      document.addEventListener('submit', this._onSubmit, true);
    }

    disconnectedCallback() {
      if (this._onSubmit) document.removeEventListener('submit', this._onSubmit, true);
      this._ready = false;
    }

    key(color, battery) {
      return color + '|' + (battery ? '1' : '0');
    }

    variantFor(unit) {
      return this.byKey[this.key(unit.color, unit.battery)] || this.variants[0];
    }

    isOk(color, battery) {
      var v = this.byKey[this.key(color, battery)];
      return !!(v && v.available);
    }

    money(cents) {
      return formatMoney(cents, this.cfg.moneyFormat);
    }

    ensureUnits(qty) {
      while (this.units.length < qty) {
        this.units.push({ color: this.units[0].color, battery: this.units[0].battery });
      }
    }

    totals(qty, discount) {
      this.ensureUnits(qty);
      var sum = 0;
      var cmp = 0;
      for (var i = 0; i < qty; i++) {
        var v = this.variantFor(this.units[i]);
        sum += v.price;
        cmp += v.compare > v.price ? v.compare : v.price;
      }
      var total = Math.max(0, sum - discount);
      return { total: total, compare: cmp, saved: Math.max(0, cmp - total), discount: discount, qty: qty };
    }

    select(pack) {
      if (!pack) return;
      this.selected = pack;
      var self = this;
      this.packs.forEach(function (p) {
        var on = p === pack;
        p.classList.toggle('is-selected', on);
        var radio = p.querySelector('.cobify-pack__radio');
        if (radio) radio.checked = on;
        var units = p.querySelector('[data-pack-units]');
        if (units && !on) units.innerHTML = '';
      });
      this.renderUnits();
      this.refreshPrices();
    }

    renderUnits() {
      var pack = this.selected;
      var box = pack.querySelector('[data-pack-units]');
      if (!box) return;
      var qty = parseInt(pack.dataset.qty, 10) || 1;
      this.ensureUnits(qty);
      box.innerHTML = '';
      var showColors = this.colors.length > 1;
      if (!showColors && !this.anyBattery) return;

      for (var i = 0; i < qty; i++) {
        var unit = this.units[i];
        var row = el('div', 'cobify-unit' + (this.cfg.blink ? ' cobify-unit--blink' : ''));
        row.dataset.unitIndex = i;
        if (qty > 1) row.appendChild(el('span', 'cobify-unit__num', '#' + (i + 1)));
        var body = el('div', 'cobify-unit__body');

        if (showColors) {
          var r1 = el('div', 'cobify-unit__row');
          var group = el('div', 'cobify-swatches');
          group.setAttribute('role', 'radiogroup');
          group.setAttribute('aria-label', 'Color' + (qty > 1 ? ' #' + (i + 1) : ''));
          for (var c = 0; c < this.colors.length; c++) {
            var name = this.colors[c];
            var b = el('button', 'cobify-swatch', '<span class="cobify-swatch__dot"></span>');
            b.type = 'button';
            b.setAttribute('role', 'radio');
            b.setAttribute('aria-label', name);
            b.title = name;
            b.dataset.unit = i;
            b.dataset.color = name;
            b.style.setProperty('--sw', this.swatchHex[name.toLowerCase()] || '#cccccc');
            b.setAttribute('aria-checked', name === unit.color ? 'true' : 'false');
            b.disabled = !this.isOk(name, unit.battery) && !this.isOk(name, !unit.battery);
            group.appendChild(b);
          }
          r1.appendChild(group);
          if (this.cfg.showName) r1.appendChild(el('span', 'cobify-unit__name', escapeHtml(unit.color)));
          body.appendChild(r1);
        }

        var r2 = el('div', 'cobify-unit__row');
        if (this.anyBattery) {
          var chips = el('div', 'cobify-chips');
          chips.setAttribute('role', 'radiogroup');
          chips.setAttribute('aria-label', 'Batería' + (qty > 1 ? ' #' + (i + 1) : ''));
          [
            { val: false, html: escapeHtml(this.cfg.labelNo || 'Sin batería') },
            { val: true, html: BATTERY_ICON + '<span>' + escapeHtml(this.cfg.labelYes || 'Con batería') + '</span>' }
          ].forEach(function (opt) {
            var chip = el('button', 'cobify-chip', opt.html);
            chip.type = 'button';
            chip.setAttribute('role', 'radio');
            chip.dataset.unit = i;
            chip.dataset.battery = opt.val ? '1' : '0';
            chip.setAttribute('aria-checked', opt.val === unit.battery ? 'true' : 'false');
            chip.disabled = !this.isOk(unit.color, opt.val);
            chips.appendChild(chip);
          }, this);
          r2.appendChild(chips);
        }
        var price = el('strong', 'cobify-unit__price', '<span class="cobify-unit__price-inner"></span>');
        price.querySelector('span').innerHTML = this.money(this.variantFor(unit).price);
        r2.appendChild(price);
        body.appendChild(r2);

        row.appendChild(body);
        box.appendChild(row);
      }
    }

    onUnitClick(btn) {
      var i = parseInt(btn.dataset.unit, 10);
      var unit = this.units[i];
      if (!unit) return;
      if (btn.dataset.color != null) {
        unit.color = btn.dataset.color;
        if (!this.isOk(unit.color, unit.battery) && this.isOk(unit.color, !unit.battery)) unit.battery = !unit.battery;
      } else if (btn.dataset.battery != null) {
        unit.battery = btn.dataset.battery === '1';
      }
      this.renderUnits();
      this.refreshPrices();
      var row = this.selected.querySelector('.cobify-unit[data-unit-index="' + i + '"] .cobify-unit__price-inner');
      if (row) {
        row.classList.add('is-bump');
        setTimeout(function () { row.classList.remove('is-bump'); }, 220);
      }
      var again = this.selected.querySelector('button[data-unit="' + i + '"][aria-checked="true"]' +
        (btn.dataset.color != null ? '[data-color]' : '[data-battery]'));
      if (again) again.focus({ preventScroll: true });
    }

    refreshPrices() {
      var self = this;
      this.packs.forEach(function (p) {
        var qty = parseInt(p.dataset.qty, 10) || 1;
        var t = self.totals(qty, parseInt(p.dataset.discount, 10) || 0);
        var priceEl = p.querySelector('[data-pack-price]');
        var cmpEl = p.querySelector('[data-pack-compare]');
        var capEl = p.querySelector('[data-pack-caption]');
        if (priceEl) priceEl.innerHTML = self.money(t.total);
        if (cmpEl) {
          cmpEl.innerHTML = self.money(t.compare);
          cmpEl.hidden = !(t.compare > t.total);
        }
        if (capEl) {
          capEl.textContent = String(p.dataset.caption || '')
            .replace(/\[amount_saved\]/g, self.money(t.saved).replace(/<[^>]*>/g, ''))
            .replace(/\[discount\]/g, self.money(t.discount).replace(/<[^>]*>/g, ''))
            .replace(/\[quantity\]/g, qty);
        }
        if (p === self.selected) self.current = t;
      });

      var cur = this.current;
      if (!cur) return;
      document.querySelectorAll('[data-cobify-price-for="' + this.sectionId + '"]').forEach(function (box) {
        var priceEl = box.querySelector('[data-cobify-price-current]');
        var cmpEl = box.querySelector('[data-cobify-price-compare]');
        if (priceEl) priceEl.innerHTML = self.money(cur.total);
        if (cmpEl) {
          cmpEl.innerHTML = self.money(cur.compare);
          cmpEl.hidden = !(cur.compare > cur.total);
        }
      });
    }

    items() {
      var qty = parseInt(this.selected.dataset.qty, 10) || 1;
      this.ensureUnits(qty);
      var map = {};
      var order = [];
      for (var i = 0; i < qty; i++) {
        var id = this.variantFor(this.units[i]).id;
        if (!map[id]) {
          map[id] = 0;
          order.push(id);
        }
        map[id] += 1;
      }
      return order.map(function (id) { return { id: id, quantity: map[id] }; });
    }

    onSubmit(e) {
      var form = e.target;
      // Ojo: form.id devolvería el <input name="id"> de Dawn; hay que leer el atributo.
      if (!(form instanceof HTMLFormElement) || form.getAttribute('id') !== this.cfg.formId) return;
      if (!this.isConnected || !this.selected) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      this.addToCart(form);
    }

    addToCart(form) {
      var self = this;
      var productForm = form.closest('product-form');
      var btn = form.querySelector('[type="submit"]');
      if (btn && btn.getAttribute('aria-disabled') === 'true') return;
      var spinner = form.querySelector('.loading__spinner');
      var errWrap = productForm ? productForm.querySelector('.product-form__error-message-wrapper') : null;
      var errMsg = errWrap ? errWrap.querySelector('.product-form__error-message') : null;
      function showError(msg) {
        if (!errWrap) {
          if (msg) alert(msg);
          return;
        }
        errWrap.hidden = !msg;
        if (msg && errMsg) errMsg.textContent = msg;
      }
      showError(false);

      if (btn) {
        btn.setAttribute('aria-disabled', 'true');
        btn.classList.add('loading');
      }
      if (spinner) spinner.classList.remove('hidden');

      var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var items = this.items();
      var payload = { items: items };
      if (cart && typeof cart.getSectionsToRender === 'function') {
        payload.sections = cart.getSectionsToRender().map(function (s) { return s.id; }).join(',');
        payload.sections_url = window.location.pathname;
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
      }
      var addUrl = (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';

      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(payload)
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) {
            showError(res.description || res.message || self.cfg.errorText);
            return;
          }
          if (!cart) {
            window.location = (window.routes && window.routes.cart_url) || '/cart';
            return;
          }
          if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
            try {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cobify-packs', productVariantId: items[0].id, cartData: res });
            } catch (err) {}
          }
          var state = Object.assign({}, res, {
            id: items[0].id,
            key: res.items && res.items[0] ? res.items[0].key : undefined
          });
          cart.renderContents(state);
        })
        .catch(function (err) {
          console.error(err);
          showError(self.cfg.errorText);
        })
        .finally(function () {
          if (btn) {
            btn.classList.remove('loading');
            btn.removeAttribute('aria-disabled');
          }
          if (spinner) spinner.classList.add('hidden');
          if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        });
    }
  }
  if (!customElements.get('cobify-packs')) customElements.define('cobify-packs', CobifyPacks);

  /* ───────── Fechas de entrega ───────── */
  class CobifyDelivery extends HTMLElement {
    connectedCallback() {
      var days = String(this.dataset.days || 'Lun, Mar, Mié, Jue, Vie, Sáb, Dom').split(',').map(function (s) { return s.trim(); });
      var months = String(this.dataset.months || 'Ene, Feb, Mar, Abr, May, Jun, Jul, Ago, Sep, Oct, Nov, Dic').split(',').map(function (s) { return s.trim(); });
      var format = this.dataset.format || 'dd_mm';
      var skip = this.dataset.skipWeekends === 'true';

      function addDays(base, n) {
        var d = new Date(base.getFullYear(), base.getMonth(), base.getDate());
        var added = 0;
        while (added < n) {
          d.setDate(d.getDate() + 1);
          if (skip && (d.getDay() === 0 || d.getDay() === 6)) continue;
          added++;
        }
        return d;
      }
      function fmt(d) {
        var dd = d.getDate();
        var mm = months[d.getMonth()] || d.getMonth() + 1;
        var wd = days[(d.getDay() + 6) % 7] || '';
        if (format === 'weekday_dd_mm') return wd + ', ' + dd + ' ' + mm;
        if (format === 'numeric') return ('0' + dd).slice(-2) + '/' + ('0' + (d.getMonth() + 1)).slice(-2);
        return dd + ' ' + mm;
      }

      var today = new Date();
      this.querySelectorAll('.cobify-delivery__step').forEach(function (step) {
        var top = step.querySelector('.cobify-delivery__top');
        if (!top) return;
        var tpl = top.dataset.template || '';
        var min = parseInt(step.dataset.min, 10) || 0;
        var max = parseInt(step.dataset.max, 10) || min;
        var a = fmt(addDays(today, min));
        var b = fmt(addDays(today, Math.max(min, max)));
        var html = tpl.replace(/\[start_date\]/g, a).replace(/\[end_date\]/g, b);
        if (a === b) html = html.replace(a + ' - ' + a, a);
        top.innerHTML = html;
      });
    }
  }
  if (!customElements.get('cobify-delivery')) customElements.define('cobify-delivery', CobifyDelivery);

  /* ───────── Barra fija de compra ───────── */
  class CobifyStickyAtc extends HTMLElement {
    connectedCallback() {
      // Se mueve al <body> para que el position: fixed no dependa de las animaciones de Dawn.
      if (this.parentElement !== document.body) {
        var section = this.dataset.section;
        document.querySelectorAll('body > cobify-sticky-atc[data-section="' + section + '"]').forEach(function (old) {
          if (old !== this) old.remove();
        }, this);
        document.body.appendChild(this);
        return;
      }
      if (this._ready) return;
      this._ready = true;

      var self = this;
      var formId = this.dataset.form;
      var btn = this.querySelector('[data-cobify-sticky-buy]');
      if (btn) {
        btn.addEventListener('click', function () {
          var form = document.getElementById(formId);
          if (!form) return;
          if (typeof form.requestSubmit === 'function') {
            var submit = form.querySelector('[type="submit"]');
            form.requestSubmit(submit || undefined);
          } else {
            var s = form.querySelector('[type="submit"]');
            if (s) s.click();
          }
        });
      }

      var target = document.getElementById(formId);
      if (!target || !('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          self.classList.toggle('is-visible', past);
          document.body.classList.toggle('cobify-sticky-on', past);
        });
      });
      this.observer.observe(target);
    }

    disconnectedCallback() {
      if (this.observer && this.parentElement !== document.body) {
        this.observer.disconnect();
        this.observer = null;
        this._ready = false;
        document.body.classList.remove('cobify-sticky-on');
      }
    }
  }
  if (!customElements.get('cobify-sticky-atc')) customElements.define('cobify-sticky-atc', CobifyStickyAtc);
})();
